import React, { Component } from 'react'
import { Input, Pagination, Checkbox, Button, Icon, Switch } from '@tinper/next-ui'
import _ from 'lodash';
import './style';
import { REFER_TYPE } from '../../utils/refer_context/referType';
import { getJsonObj, removeRepeat } from '../../utils';
import { v4 as uuid } from 'uuid';
import { TableStore, RowStore, PageStore } from 'ynf-core-engine'
import render from 'ynf-core-engine/render'
import { getRefReturn } from '../../utils/refer_context/formatter';

const CheckboxGroup = Checkbox.Group;
const X_LIB_CODE = 'ynf-lib-view' // 组件库名

export default class Dropdown extends Component {
  constructor (props) {
    super(props);
    this.referContext = props.referContext;
    try {
      this.billNo = this.referContext.props.pageStore.params.billNo;
      this.busiObj = this.referContext.props.pageStore.params.busiObj;
    } catch {
      console.error("没配置pageStore!")
    }
    this.key = this.referContext.metaDataObj.cEntityKeyFld || 'id'; // 参照主键
    this.rootStore = {}
    this.rootStore.referTableStore = new TableStore({}, this.rootStore, null, this.key)
    this.rootStore.pageStore = new PageStore({ ...this.referContext.props.pageStore, enumData: this.referContext.metaDataObj.enumData })
  }

  state = {
    dataSource: [], // 列表数据
    totalDataSource: [], // 全部数据
    selectedKeys: [], // 当前选中数据的id集合
    selectedList: [], // 当前选中数据集合
    searchResultData: [], // 搜索结果数据(前端分页搜索时用)
    isAllSelected: false, // 是否全选
  }

  componentDidMount () {
    this.getAllDataList(); // 获取全部数据
    // 回显已选数据
    let selectRowData = this.referContext.getCurrentValue();
    let selectedKeys = selectRowData.map(item => item[this.key]);
    this.setState({ selectedKeys });
  }

  // 获取全部数据
  getAllDataList = async () => {
    this.setState({ isLoading: true });
    this.referContext.props.pageStore.startLoading()
    let _res = await this.referContext.getListData({
      pageInfo: { pageIndex: 1, pageSize: 999999, total: 0 },
      exactQuery: false, // 精准搜索
      referType: REFER_TYPE.TABLE,
      dataType: 'grid',
      path: this.props.path === 'all' ? '' : this.props.path,
      billnum: this.billNo,
      busiObj: this.busiObj
    });
    let totalDataSource = _res.dataSource
    this.setState({ totalDataSource, dataSource: totalDataSource, isLoading: false });
    this.referContext.props.pageStore.endLoading()
    if (this.props.searchKey) {
      this.frontEndSearch(this.props.searchKey)
    }
  }

  // 监听选择
  onSelectRow = (row) => {
    this.referContext.props.onChangeSelect?.({
      oldValue: this.referContext.getCurrentValue(),
      currentValue: row
    });
    const { dataSource } = this.state;
    if (this.props.isMultiple) { // 多选
      this.referContext.select(row) // 将选择的值存入逻辑层
    } else { // 单选
      this.referContext.selectWithOk(row) // 将选择的值存入逻辑层
    }
    // 更新选择数据
    let selectRowData = this.referContext.getCurrentValue();
    let selectedKeys = selectRowData.map(item => item[this.key]);
    this.setState({ selectedKeys });
  }

  // 组装显示的item值
  getItemText = (val) => {
    const refReturn = getRefReturn(this.referContext.props);
    let text = '';
    refReturn.forEach((item, index) => {
      if (index !== 0) {
        text += '-' + val[item];
      } else {
        text += val[item];
      }
    })
    let result = '';
    if (text.indexOf(this.props.searchKey) > -1) {
      let rtext = text.replace(this.props.searchKey, '%$#@!%') // 分隔符
      let textList = rtext.split('%$#@!%')
      result = <span>
        {textList[0]}
        <span style={{ color: 'red' }}>{this.props.searchKey}</span>
        {textList[1]}
      </span>
    } else {
      result = text
    }
    const { selectedKeys } = this.state;
    let isChecked = false;
    if (selectedKeys.includes(val[this.key])) {
      isChecked = true
    }
    if (this.props.isMultiple) { // 多选
      return <Checkbox checked={isChecked} onChange={() => { this.selectItem(val) }} fieldid={`${this.getFieldId()}_dropdown_checkbox`}>
        {result}
      </Checkbox>
    } else {
      return <>
        {result}
        {isChecked && <Icon type="uf-correct-2" />}
      </>
    }
  }

  // 点击选择数据
  selectItem = (val) => {
    if (!this.props.isMultiple) { // 单选
      val ? this.onSelectRow([val]) : this.onSelectRow([])
    } else { // 多选
      if (this.state.selectedKeys.indexOf(val[this.key]) > -1) {
        let deleteIndex = this.state.selectedKeys.indexOf(val[this.key]);
        let invertArr = this.referContext.getCurrentValue();
        invertArr.splice(deleteIndex, 1)
        this.onSelectRow(removeRepeat(invertArr, this.key));
      } else {
        this.onSelectRow(removeRepeat([...this.referContext.getCurrentValue(), val], this.key));
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.searchKey !== this.props.searchKey) {
      this.frontEndSearch(nextProps.searchKey)
    }
  }

  // 前端搜索
  frontEndSearch = (searchKey) => {
    // const showFields = this.props.metaData?.filter(item => !item.bHidden).map(item => item.cItemName) // 显示字段
    const showFields = getRefReturn(this.referContext.props);
    const { totalDataSource, exactQuery } = this.state;
    let searchResultData = totalDataSource.filter(item => {
      for (let i = 0; i < showFields.length; i++) {
        let v = item[showFields[i]] ?? '';
        // if (exactQuery) { // 精确搜索
        //   if (v == searchKey) return true;
        // } else { // 模糊搜索
          if (v.toString().indexOf(searchKey) > -1) return true;
        // }
      }
      return false;
    })
    this.setState({ searchResultData });
  }

  getFieldId = () => {
    const { fieldid, fieldidPrefix } = this.referContext.props || {};
    return fieldid || fieldidPrefix;
  };

  // 全选
  onCheckedAll = check => {
    const { dataSource, isAllSelected } = this.state;
    if (check) { // 全选
      this.onSelectRow(removeRepeat(dataSource, this.key));
      this.setState({ selectedKeys: dataSource.map(i => i[this.key]) });
    } else { // 反选
      this.onSelectRow([]);
      this.setState({ selectedKeys: [] });
    }
    this.setState({ isAllSelected: !isAllSelected });
  }

  // 渲染下拉列表
  renderSelectList = (data) => {
    const { selectedKeys } = this.state;
    return data.map(item => {
      const text = this.getItemText(item)
      let style = {};
      if (selectedKeys.includes(item[this.key])) {
        style = { background: '#E9F0FA' }
      }
      return <div className='list-item' onClick={() => { this.selectItem(item) }} style={style} fieldid={`${this.getFieldId()}_dropdown_select`}>
        {text}
      </div>
    })
  }

  render () {
    const { dataSource, searchResultData, isAllSelected, isLoading } = this.state;
    return (
      <>
        <div className='refer-dropdown-list'>
          {
            isLoading ? <div className='loading'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_191B4C4605200011', '加载中...', undefined, {returnDom: true, placement: 'top'})}</div>
            :
            dataSource.length > 0 ?
              this.props.searchKey ?
                searchResultData.length > 0 ? this.renderSelectList(searchResultData) : <div className='loading'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_194309500558000B', '暂无搜索结果', undefined, {returnDom: true, placement: 'top'})}</div>
              : this.renderSelectList(dataSource)
            : <div className='loading'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_194309500558000C', '暂无数据', undefined, {returnDom: true, placement: 'top'})}</div>
          }
        </div>
        {
          this.props.isMultiple && 
          <div className='yyrefer-popover-btn'>
            <Checkbox checked={isAllSelected} onChange={this.onCheckedAll} fieldid={`${this.getFieldId()}_dropdown_selectall`}>
              {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_194309500558000D', '全选', undefined, {returnDom: true, placement: 'top'})}
            </Checkbox>
            <div>
              <Button className="cancel" onClick={this.referContext.closePopover} colors="secondary" fieldid={`${this.getFieldId()}_dropdown_cancle`}>
                {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_194309500558000A', '取消', undefined, {returnDom: true, placement: 'top'})}
              </Button>
              <Button onClick={() => { this.referContext.okClick(); this.referContext.closePopover() }} colors='primary' fieldid={`${this.getFieldId()}_dropdown_ok`}>
                {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0002F', '确定', undefined, {returnDom: true, placement: 'top'})}
              </Button>
            </div>
          </div>
        }
      </>
    )
  }
}
